import cn from 'classnames';
import { useEffect, useState } from 'react';

import { Fee, useCheckoutContext } from '@zooplus/checkout-state';
import { isBitiba } from '@zooplus/commons-lang';
import { TruckShipping } from '@zooplus/icons';
import { P1, CartButton } from '@zooplus/ui-components';

import { getAppConfig } from '@config/get-app-config';
import { useTranslation } from '@hooks/use-translations';
import { CHECKOUT_STATE_PROJECT_ID, FEE_TYPE } from '@utilities/constants';
import { isArrayNotEmpty } from '@utilities/utils';

import styles from './check-order-delivery-collapsed.module.scss';

const CheckOrderDeliveryCollapsed = () => {
  const {
    checkoutState,
    setDeliveryService, // TODO: Remove this after testing
  } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const { t } = useTranslation();
  const appConfig = getAppConfig();
  const fees = checkoutState?.cart?.fees;

  const [shippingFee, setShippingFee] = useState<number>(0);
  const [logisticFee, setLogisticFee] = useState<number>(0);
  const [formattedShippingFee, setFormattedShippingFee] = useState<string>('');

  useEffect(() => {
    if (isArrayNotEmpty(fees as Fee[])) {
      fees?.forEach((fee) => {
        if (fee.type === FEE_TYPE.SHIPPING) {
          setShippingFee(fee.subtotal);
          setFormattedShippingFee(fee.formattedSubtotal as string);
        }
        if (fee.type === FEE_TYPE.LOGISTICS) {
          setLogisticFee(fee.subtotal);
        }
      });
    }
  }, [fees]);

  const deliveryFee =
    !shippingFee && !logisticFee
      ? t('cart.summary.shippingFees.freeShipping')
      : formattedShippingFee;

  const selectedDeliveryServiceText =
    checkoutState?.delivery?.selectedDeliveryService?.deliveryService?.localizedName;

  // TODO: Remove this after testing
  const deliveryPayload = {
    deliveryService: {
      id: 1,
      pickUpDropOff: false,
      localizedName: 'test',
      restrictions: {
        sourceCountryIsoCode: undefined,
      },
    },
  };

  return (
    <>
      <div
        className={cn(
          styles.deliveryCollapsedWrapper,
          isBitiba(appConfig.site.domain) ? styles.applyBorderToBottom : styles.applyBorderToTop,
        )}
        data-testid="preview-article-collapsed">
        <div className={styles.deliveryCollapsedText}>
          <TruckShipping />
          <P1>{selectedDeliveryServiceText}</P1>
        </div>
        <P1 bold>{deliveryFee}</P1>
      </div>
      {/* TODO: Remove this button after testing */}
      <CartButton className="pp-mt-s" onClick={() => setDeliveryService?.(deliveryPayload)}>
        Set Delivery
      </CartButton>
    </>
  );
};

export default CheckOrderDeliveryCollapsed;
